import styled from 'styled-components';

export const Root = styled.div`
  border: none;
  cursor: pointer;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ActiveTitle = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`;

export const InactiveTitle = styled.div`
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grey5};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
`;
